import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';

import './styles/ModalRecordSeriesContent.css';
import Assets from "../../requests/apa/Asset";
import RibbonGrid from '../RibbonGridNew';

const ModalRecordSeriesContent = (props) => {
let eventSelected =  null;


  const title = props.title || false;
  const children = (
    <div className='modal-series'>
      <div className='modal-series-title'>{title}</div>
      <RibbonGrid
        ribbonsTypeMenu={'home'}
        ribbonsPrev={props.recordings}
        // user={this.props.user}
        // setMetricsEvent={this.props.setMetricsEvent}
        code={'series'}
        focusHandler={event => {
          event.from = 'ModalRecordSeriesContent';
          event.listSerieParams = props.listSerieParams || {};
          eventSelected = {...event};
        }}       
      />
    </div>
  );


  const redAction = (e) =>{    
    if(props && (typeof props.handleDeleteFromRibbonRecordings === 'function')){
      eventSelected && (typeof eventSelected  === 'object') && props.handleDeleteFromRibbonRecordings({...eventSelected});      
    }
  }

  const p = {
    children,
    callbackWhenBack: props.callbackWhenBack,
    aafNewStyle: true,
    yellowAction: (e) => props.handleClose(e),
    redAction,
    colorButtons: [
      {
        content: Translator.get('top_head_option_button_back', 'REGRESAR'),
        props: {
          color: 'yellow',
          className: 'modal-button-return',
          imgSrc: Assets.get('top_head_option_back', ''),
          onClick: (e) => props.handleClose(e, props.onShowAcceptTerm)
        }
      }
    ],
    showLogo: false,
    deleteButtonActive: true,
  };

  return <ModalWrapper {...p} />;
}

export default withOnClose(ModalRecordSeriesContent);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalRecordSeriesContent.jsx